import React, { useState, useEffect } from 'react'
import {
  Box,
  Typography,
  TableCell,
  TableRow,
  IconButton,
  makeStyles,
  Avatar,
} from '@material-ui/core'
import axios from 'axios'
import apiConfig from 'src/APIconfig/ApiConfig'
import { toast } from 'react-toastify'
import DescriptionIcon from '@material-ui/icons/Description'
import ButtonCircularProgress from 'src/component/ButtonCircularProgress'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import moment from 'moment'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import { useHistory } from 'react-router-dom'
const useStyles = makeStyles((theme) => ({
  mainbox: {
    background: theme.palette.background.dark1,
    paddingTop: '0px',
    paddingBottom: '100px',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '50px',
    },
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '0px',
    },

    '& h1': {
      fontSize: '50px',
      fontWeight: '600',
      color: theme.palette.text.black,
      marginBottom: '20px',
      paddingTop: '40px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '30px',
      },
      [theme.breakpoints.down('xs')]: {
        paddingTop: '0px',
      },
    },
  },
  mainBoxAvatar: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  box: {
    background: 'hsl(203deg 95% 93%)',
    width: 'fit-content',
    padding: '2px 10px',
    // maxWidth: '37px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // '& p': {
    //   fontSize: '10px',
    //   fontWeight: '400',
    //   background: 'hsl(203deg 95% 93%)',
    //   display: 'inline-block',
    //   padding: '1px 5px',
    // },
  },
  scorebox: {
    // backgroundColor: '#d8ffeb',
    padding: '4px',
    maxWidth: '50px',
    fontSize: '14px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  tableCell: {
    borderRight: ' .1px solid rgba(224, 224, 224, 1)',
  },
  searchBar: {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    border: '2px solid rgba(224, 224, 224, 1)',
    width: '100%',
    height: '30px',
    '& input': {
      border: 'none',
      outline: 'none',
      width: '100%',
      height: '100%',
    },
  },
  icon: {
    width: '1.23em',
    height: '1.23em',
    border: '.1px solid rgba(224, 224, 224, 1)',
    color: 'rgba(224, 224, 224, 1)',
  },
  borderBox: {
    position: 'relative',
    '&::after': {
      position: ' absolute',
      bottom: '-32px',
      width: '100%',
      height: '0px',
      content: "''",
      border: '1px solid #ccc',
      borderStyle: 'dashed',
    },
  },
  container: {
    '& .TableHeadrow': {
      '& th': {
        border: 'none',
        color: theme.palette.text.black,
      },
    },
  },
  fullList: {
    marginTop: '16px',
    position: 'relative',
    zIndex: '1',
    '& a': {
      padding: '10px',
      height: '30px',
      '& svg': {
        marginLeft: '10px',
      },
    },
  },
  texthead1: {
    color: theme.palette.text.black,
  },
}))

export default function ChildTable({ data, index, web3, auth }) {
  const classes = useStyles()
  const history = useHistory()
  const [isDownLoading, setIsDownloading] = useState(false)
  const [auditData, setAcuditData] = useState({})
  const [tokenAge, setTokenAge] = useState()
  var formatter = new Intl.NumberFormat('en-US')
  const auditViewHandler = async (contractAddress) => {
    try {
      setIsDownloading(true)
      const res = await axios({
        method: 'POST',
        url: apiConfig.auditReport,
        headers: {
          token: window.sessionStorage.getItem('token'),
        },
        data: {
          contractAddress: contractAddress,
        },
      })
      if (res.data.responseCode === 200) {
        console.log('FinalOutput', res.data.result)
        setAcuditData(res.data.result)
        // JobFitPrint()
        var fileDownload = require('js-file-download')
        fileDownload(res?.data?.contractDetails, 'auditReport.csv')
        toast.success('Your report has been downloaded successfully')
        setIsDownloading(false)
      }
    } catch (error) {
      console.log(error)
      setIsDownloading(false)
    }
  }
  const [networkBasic, setNetworkBasicInfo] = useState({})
  useEffect(() => {
    var currentTimeStamp = new Date()
    var currentTimeInMili = currentTimeStamp.getTime()
    var tokenTime = new Date(data?.contractInfo?.age)
    var tokenTimeInMili = tokenTime.getTime()

    const calciForAge = currentTimeInMili - tokenTimeInMili
    var duration = moment.duration(calciForAge, 'milliseconds')
    var days = duration.asDays()
    setTokenAge(days)
  }, [data?.contractInfo?.age])

  const getBasicInfoDataHandlerContract = async (filterKey) => {
    try {
      const res = await axios({
        method: 'GET',
        url:
          'https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=1000000&page=1&sparkline=false&price_change_percentage=1h%2C%2024h',
      })
      if (res.status === 200) {
        if (filterKey?.contractInfo?.name !== undefined) {
          const filterFun = res.data.filter((data) => {
            return (
              data?.name?.toLowerCase() ==
              filterKey?.contractInfo?.name?.toLowerCase()
            )
          })
          setNetworkBasicInfo(filterFun)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    if (data) {
      getBasicInfoDataHandlerContract(data)
    }
  }, [data])

  return (
    <TableRow key={data?.name}>
      <TableCell
        style={{
          border: '1px solid rgba(224, 224, 224, 1)',
        }}
        className="table-data table-data-first p-l-10"
      >
        <Box
          className={classes.mainBoxAvatar}
          style={{ cursor: 'pointer', justifyContent: 'space-between' }}
          onClick={() =>
            history.push({
              pathname: '/tokens',
              search: data.contractAddress,
              state: { network: data?.contractType },
            })
          }
        >
          <Box
            style={{
              display: 'flex',
              alignItem: 'center',
              justifyContent: 'center',
              width: '100%',
            }}
          >
            {data?.isTokenVerification === 'Approved' ? (
              <Avatar
                src={
                  data?.contractInfo?.image
                    ? data?.contractInfo?.image
                    : data?.tokenLogo
                    ? data?.tokenLogo
                    : networkBasic[0]?.image
                    ? networkBasic[0]?.image
                    : '/images/logo/ques.png'
                }
                alt=""
                width="100%"
              />
            ) : (
              <Avatar src={'/images/logo/ques.png'} alt="" width="100%" />
            )}

            <Box
              className={classes.texthead1}
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                marginLeft: '12px',
              }}
            >
              {data?.contractInfo?.name
                ? data?.contractInfo?.name
                : data?.name
                ? data?.name
                : ''}
              <Box
                className={classes.box}
                style={
                  data?.contractType === 'Binance'
                    ? { background: '#f0b90b' }
                    : data?.contractType === 'Polygon'
                    ? { background: '#8247e5' }
                    : { background: '#21325b' }
                }
              >
                <Typography style={{ color: '#000' }}>
                  {data?.contractInfo?.symbol
                    ? data?.contractInfo?.symbol
                    : data?.symbol
                    ? data?.symbol
                    : ''}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box>
            {data?.isTokenVerification === 'Approved' && (
              <CheckCircleIcon
                style={{ fontSize: '20px' }}
                className={classes.texthead1}
              />
            )}
          </Box>
        </Box>
      </TableCell>
      <TableCell className="table-data">
        <Box
          className={classes.scorebox}
          style={
            data?.contractScan > 75
              ? { backgroundColor: '#d8ffeb', color: '#72cc9f' }
              : data?.contractScan < 75 && data?.contractScan > 50
              ? { backgroundColor: '#fff0bf', color: '#ffb032' }
              : { backgroundColor: '#ffdcdc', color: '#ff8991' }
          }
        >
          {data?.contractScan ? Number(data?.contractScan).toFixed(2) : '0'}%
        </Box>
      </TableCell>
      <TableCell className="table-data">
        <Box className={`table-data ${classes.texthead1}`}>
          {data?.interest ? data?.interest : 0}
        </Box>
      </TableCell>
      <TableCell className={`table-data ${classes.texthead1}`}>
        {data?.contractType}
      </TableCell>
      <TableCell className={`table-data ${classes.texthead1}`}>
        $
        {data?.contractInfo?.current_price
          ? formatter.format(data?.contractInfo?.current_price)
          : data?.contractInfo?.priceInUSD
          ? formatter.format(data?.contractInfo?.priceInUSD)
          : ''}
      </TableCell>

      <TableCell
        className={`table-data ${classes.texthead1}`}
        style={{ cursor: 'pointer' }}
      >
        ${/* {isShowMarketCap ? ( */}
        <>
          {data?.contractInfo?.market_cap
            ? formatter.format(data?.contractInfo?.market_cap)
            : '0'}
        </>
        {/* // ) : (
        //   <>
        //     {data?.contractInfo?.fully_diluted_market_cap
        //       ? formatter.format(data?.contractInfo?.fully_diluted_market_cap)
        //       : '0'}
        //   </>
        // )} */}
      </TableCell>
      <TableCell className={`table-data ${classes.texthead1}`}>
        {`${parseInt(tokenAge)} Days`}
      </TableCell>
      <TableCell className={`table-data ${classes.texthead1}`}>
        {data?.shareCount ? data?.shareCount : 0}
      </TableCell>
      <TableCell
        style={{
          textAlign: 'center',
          borderRight: '1px solid rgb(224, 224, 224)',
        }}
      >
        {isDownLoading ? (
          <ButtonCircularProgress />
        ) : (
          <IconButton
            // onClick={() => printresporthandler(data?.auditReportDetails)}
            onClick={() =>
              history.push({
                pathname: '/tokens',
                search: data?.contractAddress,
                state: { network: data?.contractType, component: 'DOWNLOAD' },
              })
            }
          >
            <DescriptionIcon style={{ color: '#8299d8', cursor: 'pointer' }} />
          </IconButton>
        )}
      </TableCell>
      <Box display="none">
        {data?.auditReportDetails && (
          <div
            dangerouslySetInnerHTML={{ __html: data?.auditReportDetails }}
            id="auditReport"
          ></div>
        )}
      </Box>
    </TableRow>
  )
}
